export const PARAGRAPHS = [
  {
    id: 1,
    text: "Your Teamlytica reports are shown below. You can chose to view any report at any time. If you want to compare or benchmark two reports against each other, please click on the Compare and Benchmark tab above.",
  },
];
